module.exports = __webpack_public_path__ + "img/hm.hmeb884be.svg";